/* Joey's Houseplants theme JS — Designed & built by KAHANI | Dev: Prashanth Rathod */
(function(){
  var FREE = 150;

  /* arrives-by on PDP — nationwide shipping estimate */
  var al = document.getElementById('arrive-line'), asub = document.getElementById('arrive-sub');
  if(al){
    var now = new Date();
    function f(d){ return d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'}); }
    var a = new Date(now); a.setDate(a.getDate()+2);
    var b = new Date(now); b.setDate(b.getDate()+4);
    al.textContent = 'Arrives ' + f(a) + ' – ' + f(b);
    if(asub) asub.textContent = 'shipped bare-root with our arrive-safe promise';
  }

  /* scroll reveals — pre-trigger 240px before entering viewport */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); },{threshold:0, rootMargin:'0px 0px 240px 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); }

  /* mobile menu */
  var mt = document.querySelector('[data-menu-toggle]');
  if(mt) mt.addEventListener('click', function(){
    var m = document.getElementById('mobile-menu');
    var open = m.classList.toggle('open');
    mt.setAttribute('aria-expanded', open);
  });

  /* footer year */
  document.querySelectorAll('.jyr').forEach(function(el){ el.textContent = new Date().getFullYear(); });

  /* PDP: thumbs, variant pills, qty */
  document.querySelectorAll('[data-thumb]').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('[data-thumb]').forEach(function(b){ b.classList.remove('sel'); });
      btn.classList.add('sel');
      document.getElementById('main-img').src = btn.dataset.thumb;
    });
  });
  document.querySelectorAll('.size-opt').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(btn.dataset.soldout) return;
      document.querySelectorAll('.size-opt').forEach(function(b){ b.classList.remove('sel'); });
      btn.classList.add('sel');
      var v = document.getElementById('pdp-variant'); if(v) v.value = btn.dataset.variant;
      var p = document.getElementById('pdp-price'); if(p) p.textContent = btn.dataset.price;
    });
  });
  var qty = 1;
  document.querySelectorAll('[data-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      qty = Math.min(9, Math.max(1, qty + parseInt(btn.dataset.qty,10)));
      var o = document.getElementById('qty-out'); if(o) o.textContent = qty;
      var i = document.getElementById('pdp-qty'); if(i) i.value = qty;
    });
  });
  var giftCb = document.getElementById('gift-cb');
  if(giftCb) giftCb.addEventListener('change', function(){
    document.getElementById('gift-note-field').style.display = this.checked ? 'block' : 'none';
  });

  /* ---------- CART DRAWER (Shopify AJAX) ---------- */
  var overlay = document.getElementById('jc-overlay');
  var drawer = document.getElementById('jc-drawer');
  function money(cents){ return '$' + (cents/100).toFixed(2).replace(/\.00$/,''); }
  function openDrawer(){ refresh().then(function(){ overlay.classList.add('open'); drawer.classList.add('open'); }); }
  function closeDrawer(){ overlay.classList.remove('open'); drawer.classList.remove('open'); }
  if(overlay) overlay.addEventListener('click', closeDrawer);
  var jcClose = document.getElementById('jc-close');
  if(jcClose) jcClose.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });
  document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click', openDrawer); });

  /* Show the meter first, then a pot in the same cart drawer slot. */
  var METER_ID = 8594509103138;
  var POT_IDS = [8600295571490, 8600293212194];
  var POT_HANDLES = ['smooth-10-pot', 'fluted-11-pot'];
  var upsellRequest = 0;
  function upsell(cart){
    var box = document.getElementById('jc-upsell');
    if(!box) return;
    var request = ++upsellRequest;
    if(!cart.items.length){ box.innerHTML = ''; return; }
    var hasMeter = cart.items.some(function(item){ return item.product_id === METER_ID; });
    var hasPot = cart.items.some(function(item){ return POT_IDS.indexOf(item.product_id) !== -1; });
    if(hasMeter && hasPot){ box.innerHTML = ''; return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function getProduct(handle){
      return fetch(root + 'products/' + handle + '.js').then(function(response){
        if(!response.ok) throw new Error('Product unavailable');
        return response.json();
      });
    }
    function addVariant(variant, button){
      button.disabled = true;
      button.textContent = 'Adding…';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: variant.id, quantity: 1})
      })
        .then(function(response){ if(!response.ok) throw new Error('Could not add item'); return response.json(); })
        .then(refresh)
        .catch(function(){ button.disabled = false; button.textContent = 'Try again'; });
    }
    if(!hasMeter){
      getProduct('moisture-meter').then(function(product){
        if(request !== upsellRequest) return;
        var variant = product.variants && product.variants.find(function(item){ return item.available && !item.requires_selling_plan; });
        if(!product.available || !variant){ box.innerHTML = ''; return; }
        box.innerHTML = '<div class="jc-up-h">Keep your new plant watered just right</div>' +
          '<div class="jc-item"><img alt=""><div><div class="n"></div><div class="v"></div></div>' +
          '<button class="jc-up-add" type="button" aria-label="Add Moisture Meter to cart">Add</button></div>';
        var image = box.querySelector('img');
        image.src = product.featured_image || '';
        image.alt = product.title;
        box.querySelector('.n').textContent = product.title;
        box.querySelector('.v').textContent = money(variant.price);
        box.querySelector('.jc-up-add').addEventListener('click', function(){ addVariant(variant, this); });
      }).catch(function(){ if(request === upsellRequest) box.innerHTML = ''; });
      return;
    }
    Promise.all(POT_HANDLES.map(getProduct)).then(function(products){
      if(request !== upsellRequest) return;
      products = products.filter(function(product){
        return product.available && product.variants && product.variants.some(function(variant){
          return variant.available && !variant.requires_selling_plan;
        });
      });
      if(!products.length){ box.innerHTML = ''; return; }
      box.innerHTML = '<div class="jc-up-h">Add a pot for your new plant</div>' +
        '<div class="jc-item"><img alt=""><div><div class="n"></div><div class="v"></div></div>' +
        '<button class="jc-up-add" type="button" aria-label="Add selected pot to cart">Add</button></div>' +
        '<div class="jc-up-options" style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin:12px 0 2px">' +
        '<label style="display:block;min-width:0;font-size:12px;font-weight:700;color:#345b3a">Pot style <select class="jc-up-style" style="display:block;width:100%;margin-top:5px;padding:9px 8px;border:1px solid #aab9a8;border-radius:8px;background:#fff;color:#1d2d1c"></select></label>' +
        '<label style="display:block;min-width:0;font-size:12px;font-weight:700;color:#345b3a">Color <select class="jc-up-color" style="display:block;width:100%;margin-top:5px;padding:9px 8px;border:1px solid #aab9a8;border-radius:8px;background:#fff;color:#1d2d1c"></select></label></div>'; 
      var style = box.querySelector('.jc-up-style');
      var color = box.querySelector('.jc-up-color');
      var button = box.querySelector('.jc-up-add');
      products.forEach(function(product, index){
        var option = document.createElement('option');
        option.value = String(index);
        option.textContent = product.title;
        style.appendChild(option);
      });
      function availableVariants(){
        return products[Number(style.value)].variants.filter(function(variant){
          return variant.available && !variant.requires_selling_plan;
        });
      }
      function updatePot(){
        var product = products[Number(style.value)];
        var variant = availableVariants().find(function(item){ return String(item.id) === color.value; }) || availableVariants()[0];
        if(!variant) return;
        var image = box.querySelector('img');
        image.src = (variant.featured_image && variant.featured_image.src) || product.featured_image || '';
        image.alt = product.title + ' - ' + (variant.option1 || variant.title);
        box.querySelector('.n').textContent = product.title;
        box.querySelector('.v').textContent = money(variant.price);
      }
      function updateColors(){
        color.innerHTML = '';
        availableVariants().forEach(function(variant){
          var option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.option1 || variant.title;
          color.appendChild(option);
        });
        updatePot();
      }
      style.addEventListener('change', updateColors);
      color.addEventListener('change', updatePot);
      button.addEventListener('click', function(){
        var variant = availableVariants().find(function(item){ return String(item.id) === color.value; });
        if(variant) addVariant(variant, button);
      });
      updateColors();
    }).catch(function(){ if(request === upsellRequest) box.innerHTML = ''; });
  }

  function render(cart){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = cart.item_count; });
    var ship = document.getElementById('jc-ship'), items = document.getElementById('jc-items');
    if(!ship) return;
    var sub = cart.total_price;
    var freeCents = FREE * 100;
    if(sub >= freeCents){ ship.innerHTML = 'You’ve unlocked free nationwide shipping!<div id="jc-bar"><i style="width:100%"></i></div>'; }
    else { ship.innerHTML = money(freeCents - sub) + ' away from free nationwide shipping<div id="jc-bar"><i style="width:' + Math.round(sub/freeCents*100) + '%"></i></div>'; }
    if(!cart.items.length){
      items.innerHTML = '<div id="jc-empty">Your cart is empty.<br>Your future jungle disagrees.</div>';
    } else {
      items.innerHTML = cart.items.map(function(i, idx){
        return '<div class="jc-item"><img src="' + (i.image || '') + '&width=120" alt=""><div><div class="n">' + i.product_title + '</div>' +
          (i.variant_title && i.variant_title !== 'Default Title' ? '<div class="v">' + i.variant_title + '</div>' : '') +
          '<div class="jc-qty"><button data-line="' + (idx+1) + '" data-d="-1">−</button><span>' + i.quantity + '</span><button data-line="' + (idx+1) + '" data-d="1">+</button></div></div>' +
          '<div class="p">' + money(i.final_line_price) + '</div></div>';
      }).join('');
      items.querySelectorAll('[data-line]').forEach(function(b){
        b.addEventListener('click', function(){
          var line = parseInt(b.dataset.line,10);
          var item = cart.items[line-1];
          var q = item.quantity + parseInt(b.dataset.d,10);
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:Math.max(0,q)})})
            .then(function(r){ return r.json(); }).then(render);
        });
      });
    }
    var co = document.getElementById('jc-checkout');
    if(co) co.textContent = cart.items.length ? 'Checkout — ' + money(sub) : 'Checkout';
    upsell(cart);
  }
  function refresh(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ render(c); return c; }); }
  refresh();

  /* gift note -> cart attribute */
  var gcb = document.getElementById('jc-gift-cb');
  if(gcb){
    gcb.addEventListener('change', function(){ document.getElementById('jc-gift-txt').style.display = this.checked ? 'block' : 'none'; });
    document.getElementById('jc-gift-txt').addEventListener('change', function(){
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Gift note': this.value}})});
    });
  }

  /* quick add buttons */
  document.querySelectorAll('[data-add-variant]').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.disabled = true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id: parseInt(btn.dataset.addVariant,10), quantity:1})})
        .then(function(r){ return r.json(); })
        .then(function(){ btn.disabled = false; openDrawer(); });
    });
  });

  /* PDP add-to-cart via AJAX */
  var pdpForm = document.getElementById('pdp-form');
  if(pdpForm){
    pdpForm.addEventListener('submit', function(e){
      if(e.submitter && e.submitter.classList.contains('atc')){
        e.preventDefault();
        var fd = new FormData(pdpForm);
        fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){ return r.json(); }).then(function(){ openDrawer(); });
      }
    });
  }
})();

/* Complete Setup included-image lightbox — mobile + desktop */
(function(){
  if(window.JHSetupImageZoom) return;
  window.JHSetupImageZoom = true;

  var style = document.createElement('style');
  style.textContent =
    '.jh-values img{cursor:zoom-in;}' +
    '.jh-zoom-overlay{position:fixed;inset:0;z-index:10000;background:rgba(10,18,8,.88);display:flex;align-items:center;justify-content:center;padding:22px;opacity:0;visibility:hidden;transition:opacity .18s ease,visibility .18s ease;}' +
    '.jh-zoom-overlay.is-open{opacity:1;visibility:visible;}' +
    '.jh-zoom-overlay img{display:block;max-width:min(92vw,1100px);max-height:88vh;width:auto;height:auto;object-fit:contain;border-radius:14px;background:#fff;box-shadow:0 20px 70px rgba(0,0,0,.35);}' +
    '.jh-zoom-close{position:absolute;top:max(16px,env(safe-area-inset-top));right:16px;width:46px;height:46px;border:0;border-radius:50%;background:#fff;color:#173404;font-size:30px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 6px 22px rgba(0,0,0,.2);}' +
    '@media(max-width:749px){.jh-zoom-overlay{padding:14px}.jh-zoom-overlay img{max-width:96vw;max-height:82vh;border-radius:12px}.jh-zoom-close{right:12px;width:44px;height:44px;font-size:28px}}';
  document.head.appendChild(style);

  var overlay = document.createElement('div');
  overlay.className = 'jh-zoom-overlay';
  overlay.setAttribute('role','dialog');
  overlay.setAttribute('aria-modal','true');
  overlay.setAttribute('aria-label','Enlarged product image');
  overlay.innerHTML = '<button type="button" class="jh-zoom-close" aria-label="Close enlarged image">×</button><img alt="">';
  document.body.appendChild(overlay);

  var zoomImg = overlay.querySelector('img');
  var closeBtn = overlay.querySelector('.jh-zoom-close');
  var lastTrigger = null;

  function bestSource(img){
    var set = img.getAttribute('srcset');
    if(set){
      var choices = set.split(',').map(function(part){
        var bits = part.trim().split(/\s+/);
        var width = parseInt(bits[1],10) || 0;
        return {url:bits[0],width:width};
      }).sort(function(a,b){return b.width-a.width;});
      if(choices[0] && choices[0].url) return choices[0].url;
    }
    return img.currentSrc || img.src;
  }

  function openZoom(img){
    lastTrigger = img;
    zoomImg.src = bestSource(img);
    zoomImg.alt = img.alt || 'Included item';
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    closeBtn.focus({preventScroll:true});
  }

  function closeZoom(){
    if(!overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function(){ zoomImg.removeAttribute('src'); },180);
    if(lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus({preventScroll:true});
  }

  document.addEventListener('click',function(e){
    var img = e.target.closest && e.target.closest('.jh-values img');
    if(img){
      e.preventDefault();
      openZoom(img);
      return;
    }
    if(e.target === overlay) closeZoom();
  });

  closeBtn.addEventListener('click',closeZoom);
  document.addEventListener('keydown',function(e){
    if(e.key === 'Escape') closeZoom();
  });
})();
